import styled from 'styled-components';
import { tagStyles } from 'Styles/styles';

export const TagWrapper = styled.div`
  border-radius: 3px;
  box-shadow: 2px 2px 5px 0 rgb(0 0 0 / 6%);
  border: ${({ theme }) => `solid 1px ${theme.borders.importanceMeter}`};
  background-color: ${({ theme }) => theme.buttons.custom.background};
  color: ${({ theme }) => theme.text.workspaceItem};
  display: inline-block;
  padding: 3px 7px;
  margin-top: 5px;
`;
TagWrapper.displayName = 'TagWrapper';

export const TagStyles = styled.span`
  ${tagStyles};
  color: inherit;
  font-weight: 500;
  cursor: pointer;
`;
TagStyles.displayName = 'TagStyles';
